import React, { useState } from "react";
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as CheckedIcon } from '../../assets/default/images/checked-icon.svg'
import { ReactComponent as UncheckedIcon } from '../../assets/default/images/unchecked-icon.svg'

import { getSS } from '../../helpers'

interface GiftAidProps {
  [key: string]: any
}

const GiftAid: React.FC<GiftAidProps> = (props:any) => {

  const homepage = getSS('membership')
  const [ showMore, setShowMore ] = useState(false)

  return (
    <>
      <div className="row">
        <div className="giftaid clearfix">
          <div className="large-12 columns box-top">
            <img src="/assets/default/images/giftaid.png" alt="Gift Aid Logo" className="logo"/>
            <h2>Are you a UK taxpayer? Turn your gift of
              <span> £{(homepage?.amount)?.toFixed(2)} </span>
              { homepage?.payment_type === 'Regular' &&
                <span className="normal"> per year </span>
              }
              into <span> £{(homepage.amount*1.25)?.toFixed(2)} </span>
              { homepage.payment_type === 'Regular' &&
                <span className="normal"> per year </span>
              }
              at no extra cost to you.
            </h2>
          </div>
          <div className="medium-6 columns box-bottom">
            <div className={`inner clearfix ${props.values.optins_giftaid === true ? 'active' : ''}`}>
              <FormControlLabel
                style={{display:'table'}}
                control={
                  <div style={{display:'table-cell'}}>
                    <Checkbox
                      onChange={props.handleChange}
                      name="optins_giftaid"
                      id="gift-aid-checkbox"
                      checked={props.values.optins_giftaid}
                      icon={<SvgIcon><UncheckedIcon /></SvgIcon>}
                      checkedIcon={<SvgIcon><CheckedIcon /></SvgIcon>}
                      color="primary"
                    />
                  </div>
                }
                label="YES, I would like Royal Botanic Gardens, Kew to reclaim Gift Aid on any membership subscriptions or donations that I have made over the last four years and in the future, until I notify you otherwise."
                labelPlacement="end"
              />
            </div>
          </div>
          <div className="medium-6 columns box-bottom">
            <p className="giftaid-declaration info">
              I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations or membership subscriptions in that tax year it is my responsibility to pay any difference.&nbsp;
              { !showMore &&
                <button type="button" className="link" onClick={() => setShowMore(true)} tabIndex={0}>Show more</button>
              }
              { showMore &&
                <>
                  <span className="showMore">Gift Aid is reclaimed by the charity from the tax you pay for the current tax year. If you pay Income Tax at the higher or additional rate and want to receive the additional tax relief due to you, you must include all your Gift Aid donations on your Self-Assessment tax return or ask HM Revenue and Customs to adjust your tax code. Your address is needed to identify you as a current UK taxpayer.</span>
                  <button type="button" className="link" onClick={() => setShowMore(false)} tabIndex={0}>Show less</button>
                </>
              }
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GiftAid;